var map = {
	"./About.vue": 3419,
	"./Career.vue": 6201,
	"./Contacts.vue": 5934,
	"./Main.vue": 5808,
	"./NewsFeed.vue": 8931,
	"./NewsPage.vue": 8935,
	"./Portfolio.vue": 2736,
	"./PortfolioPage.vue": 3846,
	"./Prices.vue": 4572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4681;